// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import store from '@/store'
import router from '@/router'
import i18n from '@/locale/index.js'
import App from './App.vue'

// import 'font-awesome-webpack'
//引入UI组件
import ElementUI from 'element-ui'
import '@/assets/theme/index.css'
import '@/util/statistics.js'
// flow-center
import './libs/flow-center'
import './libs/oppein-component'
import { addFormValidateJs } from '@oppein/op-web-form'
Vue.use(ElementUI)

//引入sass生产的css
import '@/assets/css/style.css'
//引入vue全局拓展工具
import '@/util/index'

Vue.config.productionTip = false
router.beforeEach(async (to, from, next) => {
  try {
    if (!store.state.auth.user) {
      let res = await store.dispatch('checkLogin')
      if (res.status && res.data && res.data.id) {
        window.opCollect.setMtdsId(res.data.id) // B端用户id
        window.opCollect.init({
          appCode: 'OPUC', // appCode
          subAppCode: 'OPUCPC001', // subAppCode
          eventType: ['click'], // pc用click，移动端用touchend
        })
      }
    }
    if (!store.state.auth.permission) {
      await store.dispatch('getMenusByUser')
    }
  } catch (err) {
    if (!to.meta.white) {
      next({ path: '/main/errorView' })
    }
  }
  if (to.meta.white || (store.state.auth.user.id && store.state.auth.permission)) {
    if (store.state.auth.permission.indexOf('system-maintenance') !== -1) {
      if (to.meta.white) {
        next()
      } else {
        next({ path: '/302' })
      }
    } else {
      next()
    }
  } else {
    if (!to.meta.white) {
      next({ path: '/main/errorView' })
    }
  }
})

/* eslint-disable no-new */
// const app = new Vue({
//     el: '#app',
//     store,
//     router,
//     i18n,
//     template: '<router-view></router-view>',
//     watch: {
//         $route(to) {
//           this.$store.commit('setDicFlags',{})
//           this.checkServiceDictionary()
//         }
//     },
// })
const app = new Vue({
  el: '#app',
  store,
  router,
  i18n,
  render: (h) => h(App),
}).$mount('#app')

addFormValidateJs(app)
app && app.$validator && app.$validator.localize('zh-CN')
